import React from 'react';
import { Clock, Moon } from 'lucide-react';
export function EmotionalHook() {
  return <section className="py-24 px-4 relative" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <span className="text-amber-500 text-sm tracking-widest uppercase mb-4 block" data-id="element-25">
            Fase 1
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-zinc-100 mb-6" data-id="element-26">
            El Juicio de Medianoche
          </h2>
          <div className="w-12 h-1 bg-amber-500/50 mx-auto" data-id="element-27"></div>
        </div>

        <div className="space-y-12" data-id="element-28">
          <div className="bg-zinc-900/50 border border-zinc-800 p-8 md:p-12 relative overflow-hidden" data-id="element-29">
            <Clock className="absolute -right-4 -top-4 w-32 h-32 text-zinc-800/30" data-id="element-30" />
            <h3 className="text-xl text-amber-400 mb-4 flex items-center gap-3" data-id="element-31">
              <Moon className="w-5 h-5" data-id="element-32" />
              El Problema
            </h3>
            <p className="text-lg text-zinc-300 leading-relaxed relative z-10" data-id="element-33">
              Son las 12:45 AM. Estás en silencio, pero en tu cabeza hay un
              ruido ensordecedor. Reensayas discusiones de hace 5 años. Esperas
              una disculpa que cure la herida.
            </p>
          </div>

          <div className="border-l-2 border-amber-600 pl-8 md:pl-12 py-4" data-id="element-34">
            <h3 className="text-xl text-amber-500 mb-4 font-serif" data-id="element-35">
              La Realidad Cruda
            </h3>
            <p className="text-xl md:text-2xl text-zinc-400 leading-relaxed font-light" data-id="element-36">
              Si tu sanación depende de que el otro admita su error,{' '}
              <span className="text-zinc-100 font-medium" data-id="element-37">
                eres su esclavo emocional
              </span>
              . Estás financiando el estilo de vida de quien te dañó con tu
              propio sufrimiento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}